import React from 'react';

import { debounce } from 'lodash-es';
import { injectIntl, InjectedIntl } from 'react-intl';

import Tabs, { TabPanel, Tab, TabList } from '@atlaskit/tabs';
import Textfield from '@atlaskit/textfield';

import { Repository } from 'src/components/types';
import { Ref } from 'src/sections/repository/types';

import FilteredRefList from '../../containers/ref-selector/filtered-ref-list';

import messages from './ref-selector.i18n';
import * as styles from './ref-selector.style';

const FILTER_DEBOUNCE_INTERVAL = 200;

type RefSelectorPanelProps = {
  intl: InjectedIntl;
  onRefSelected?: (ref: Ref) => void;
  renderRef?: (ref: Ref) => any;
  repository: Repository;
  setInitialFocusRef: (ref: HTMLElement) => void;
};

type RefSelectorPanelState = {
  filter: string;
  selectedTabIndex: number;
};

class RefSelectorPanel extends React.PureComponent<
  RefSelectorPanelProps,
  RefSelectorPanelState
> {
  state = {
    filter: '',
    selectedTabIndex: 0,
  };

  handleFilterChange = debounce(
    filter => this.setState({ filter }),
    FILTER_DEBOUNCE_INTERVAL
  );

  // @ts-ignore TODO: fix noImplicitAny error here
  onTabSelected = tabIndex => {
    this.setState({ selectedTabIndex: tabIndex });
  };

  placeholders = [
    this.props.intl.formatMessage(messages.filterBranches),
    this.props.intl.formatMessage(messages.filterTags),
  ];

  render() {
    const { selectedTabIndex, filter } = this.state;
    const { intl, onRefSelected, renderRef, repository, setInitialFocusRef } =
      this.props;
    return (
      <styles.RefSelectorPanel>
        <styles.Filter>
          <Textfield
            ref={setInitialFocusRef}
            aria-label={`${this.placeholders[selectedTabIndex]}`}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              this.handleFilterChange(e.target.value);
            }}
            placeholder={this.placeholders[selectedTabIndex]}
          />
        </styles.Filter>

        <Tabs
          id="ref-selector-tabs"
          onChange={this.onTabSelected}
          selected={selectedTabIndex}
        >
          <TabList>
            <Tab>{intl.formatMessage(messages.branchesTab)}</Tab>
            <Tab>{intl.formatMessage(messages.tagsTab)}</Tab>
          </TabList>
          <TabPanel>
            <FilteredRefList
              filter={filter}
              onRefSelected={onRefSelected}
              renderRef={renderRef}
              repository={repository}
              type="branch"
            />
          </TabPanel>
          <TabPanel>
            <FilteredRefList
              filter={filter}
              onRefSelected={onRefSelected}
              renderRef={renderRef}
              repository={repository}
              type="tag"
            />
          </TabPanel>
        </Tabs>
      </styles.RefSelectorPanel>
    );
  }
}

export default injectIntl(RefSelectorPanel);
